import React, { useEffect, useRef, useState } from "react";
import { TopArrow } from "../../../assets/images";
import "./ScrollToTop.scss";
const ScrollToTop = () => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const scrollTop = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    window.scroll({
      top: position.top,
      left: position.left,
      behavior: "smooth",
    });
  }, [position]);

  useEffect(() => {
    window.addEventListener("scroll", (e) => {
      if (scrollTop.current) {
        window.scrollY > 200
          ? (scrollTop.current.style.display = "inline-block")
          : (scrollTop.current.style.display = "none");
      }
    });
  });

  return (
    <div
      onClick={() => setPosition({ top: 0, left: 0 })}
      className="scroll-top-button"
      ref={scrollTop}
    >
      <div className="scroll-top-inner">
        <img src={TopArrow} alt="top arrow" />
        <div>Back To Top</div>
      </div>
    </div>
  );
};

export default ScrollToTop;
